import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SelectableSwiper from './components/selectableSwiper/selectableSwiper';

const root = ReactDOM.createRoot(document.getElementById('landingPage'));
root.render(
    <SelectableSwiper {...{
        selectors: [
            {
                src: 'https://fakeimg.pl/80/?text=0',
                alt: '0'
            },
            {
                src: 'https://fakeimg.pl/80/?text=1',
                alt: '1'
            },
            {
                src: 'https://fakeimg.pl/80/?text=2',
                alt: '2'
            },
            {
                src: 'https://fakeimg.pl/80/?text=3',
                alt: '3'
            },
            {
                src: 'https://fakeimg.pl/80/?text=4',
                alt: '4'
            },
            {
                src: 'https://fakeimg.pl/80/?text=5',
                alt: '5'
            },
        ],
        items: [
            [
                {
                    src: 'https://fakeimg.pl/350/?text=00',
                    alt: '0-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=01',
                    alt: '0-1'
                }
            ],
            [
                {
                    src: 'https://fakeimg.pl/350/?text=11',
                    alt: '1-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=12',
                    alt: '1-1'
                }
            ],
            [
                {
                    src: 'https://fakeimg.pl/350/?text=21',
                    alt: '2-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=22',
                    alt: '2-1'
                }
            ],
            [
                {
                    src: 'https://fakeimg.pl/350/?text=31',
                    alt: '3-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=332',
                    alt: '3-1'
                }
            ],
            [
                {
                    src: 'https://fakeimg.pl/350/?text=441',
                    alt: '4-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=42',
                    alt: '4-1'
                }
            ],
            [
                {
                    src: 'https://fakeimg.pl/350/?text=51',
                    alt: '5-0'
                },
                {
                    src: 'https://fakeimg.pl/350/?text=52',
                    alt: '5-1'
                }
            ]
        ]
    }}/>
);